import { translate } from './localizationUtils';

import { updateButtonTextSaga, ANIMATED_DOTS } from '../sagas/animateButtonSagas';

export function getOptionsForUpdateButton(store) {
    return {
        pendingText: ANIMATED_DOTS,
        pendingClass: '.c-generic-email-submit--pending',
        changeToText: translate(store.getState(), 'generic-email-submit-email-success')
    };
}
